import React from 'react';
import { Button } from '@itwin/itwinui-react';
import { useConfigContext } from '../../../context';
import { t } from '../../../services/translation';
import { readUniversalLinkParams } from '../searchParams/searchParams';
import { useTeamsLink } from './useTeamsLink';

export function TeamsLink(): JSX.Element | null {
  const { config } = useConfigContext();

  const teamsLink = useTeamsLink();

  const { workAreaId, projectId, app } = readUniversalLinkParams();

  function navigateLink(): void {
    window.location.href = teamsLink;
  }

  if (
    !workAreaId ||
    !projectId ||
    app == 'webview' ||
    config.DataAccessLevel == 'Datasource' ||
    !teamsLink
  ) {
    return null;
  }

  return (
    <Button
      onClick={navigateLink}
      data-link={teamsLink}
      data-testid="microsoft-teams-button"
    >
      {t('ProductName.MicrosoftTeams')}
    </Button>
  );
}
